import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";
import {
  AndroidIcon,
  ReactNativeIcon,
  FlutterIcon,
  AppleIcon,
} from "../../icons";

interface Step3Props {
  productType: string;
  onUpdateState: (value: string) => void;
}

const Step3Platform: React.FC<Step3Props> = ({
  productType,
  onUpdateState,
}) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">
            Which platform will you be installing SDK on?
          </h2>
          <div className="platform-buttons">
            <PulseSelectButton
              options={[
                {
                  label: "NATIVE iOS",
                  value: "ios",
                  icon: <AppleIcon />,
                },
                {
                  label: "NATIVE ANDROID",
                  value: "android",
                  icon: <AndroidIcon />,
                },
                {
                  label: "REACT NATIVE",
                  value: "reactnative",
                  icon: <ReactNativeIcon />,
                },
                {
                  label: "FLUTTER",
                  value: "flutter",
                  icon: <FlutterIcon />,
                },
              ]}
              value={productType}
              onChange={onUpdateState}
              variant="platform"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step3Platform;
